<script setup lang="ts">
import MessageLayout from '@/components/assistant/chat/message/MessageLayout.vue'
import type {SystemMessage} from '@/client/mentor/MessagesClient'
import {ErrorCode} from '@/client/mentor/types'

const USAGE_LIMIT_ERROR_CODES: string[] = [
  ErrorCode.NOT_ENOUGH_CREDITS,
  ErrorCode.TOO_MANY_PENDING_CREDITS,
  ErrorCode.TOO_MANY_PENDING_MESSAGES,
]

defineProps<{
  message: SystemMessage
}>()
</script>

<template>
  <div class="flex flex-col gap-2">
    <MessageLayout class="border-new-sm border-new-neutral-100 bg-new-neutral-0 print:border-none" :message="message">
      <div class="text-new-neutral-500">
        {{
          USAGE_LIMIT_ERROR_CODES.includes(message.content.errorCode)
            ? $t('assistant.chat.message.errorNote.usageLimit')
            : $t('assistant.chat.message.errorNote.error')
        }}
      </div>
    </MessageLayout>
  </div>
</template>
